import { MdLocationOn } from "react-icons/md";
import { BiLogoFacebookCircle, BiLogoInstagramAlt } from "react-icons/bi";

export const items = [
  {
    id: 1,
    href: "https://maps.app.goo.gl/TiqRtNMAsyfsaKfi8",
    icon: MdLocationOn,
    label: "San Juan 1219, Mendoza",
  },
  {
    id: 2,
    href: "https://www.facebook.com/NupraMultiespacio",
    icon: BiLogoFacebookCircle,
    label: "Nupra Multiespacio",
  },
  {
    id: 3,
    href: "https://www.instagram.com/nupramultiespacio/",
    icon: BiLogoInstagramAlt,
    label: "@nupramultiespacio",
  },
];
